import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import { getUserPrcData, LOADING_STATE } from 'components/Login/redux';
import PropTypes from 'prop-types';
import { loadNudgeData } from 'reduxUtils/modules/translationConfig';
import { clearAmpParams, getPrcCookieValue } from 'utils/primeUtil';
import {
  PRC_FOR_SUBSCRIBED,
  PRC_FOR_FTU,
  PRC_FOR_NOT_LOGIN,
  PRC_FOR_NEVER_REGISTER,
  // PRC_FOR_NEVER_REGISTER,
  // PRC_FOR_NOT_LOGIN,
} from 'constants/index';
import _isEqual from 'lodash.isequal';

const withNudgeLogic = (WrappedComponent, pageType) => {
  const NudgeLogicHOC = props => {
    const [nudgeText, setNudgeText] = useState(null);
    const [isPayPerStoryUser, setPayPerUSer] = useState(false);
    const [replaceDate, setReplaceDate] = useState('');
    const [preExpireHeading, setPreExpireHeading] = useState('');
    const [showFreeTrailBlocker, setShowFreeTrailBlocker] = useState(false);

    const {
      loadTOIPlusNudgeData,
      isWapView,
      geo,
      userData,
      homePagenudges,
      storyPageNudges,
      storyPageNudgesNew,
      primeStripNudges,
      payPerStoryNudges,
      PrintHomePage,
      PrintStoryPage,
      upgradePlan,
      inGracePeriod,
      graceDate,
      daysRemaining,
      ispreExpired,
      frmapp,
      bundleCardMessage,
      storyPageOffers,
      // accessPayload,
      viewType,
      isUpgrade,
      // transLoading,
      storyBlockerNewPaywall,
      toiHPWidget,
      showFreeTrailBlockerState,
      isAppView,
      loading,
    } = props;

    const getNudges = () => {
      switch (pageType) {
        case 'homepage':
          return homePagenudges;
        case 'storypage':
          return storyPageNudges;
        case 'storypagenew':
          if (isUpgrade) {
            return upgradePlan;
          }
          if (viewType === 'printHomePage') {
            return PrintHomePage;
          } else if (viewType === 'printArticleShow') {
            return PrintStoryPage;
          }
          return storyPageNudgesNew;
        case 'storyPagePinkStrip':
          return isPayPerStoryUser ? payPerStoryNudges : primeStripNudges;
        case 'storyBlockerV3':
          if (isUpgrade) {
            return upgradePlan;
          }
          if (viewType === 'printHomePage') {
            return PrintHomePage;
          } else if (viewType === 'printArticleShow') {
            return PrintStoryPage;
          }
          return storyBlockerNewPaywall;
        case 'homepagerenewnudge':
          return toiHPWidget;
        default:
          return null;
      }
    };

    let nudges = getNudges();

    useEffect(
      () => {
        nudges = getNudges();
      },
      [
        userData,
        inGracePeriod,
        ispreExpired,
        showFreeTrailBlockerState,
        isUpgrade,
      ],
    );

    const onRetryToipTransCallback = () => {
      if (geo?.currentCountry) {
        loadTOIPlusNudgeData(isWapView, geo?.currentCountry);
      }
    };

    useEffect(
      () => {
        if (
          userData?.isLoggedIn &&
          (!loading || loading === LOADING_STATE.LOADING)
        ) {
          return;
        }
        if (nudges) {
          let prcValue = getPrcCookieValue();
          while (prcValue >= 0) {
            if (prcValue === 1 || prcValue === 5) {
              prcValue = -1;
            }
            const key = `prc${prcValue}`;
            if (nudges[key]) {
              setNudgeText(nudges[key]);
              break;
            } else {
              setNudgeText(null);
            }
            prcValue -= 1;
          }
        }
      },
      [
        nudges,
        userData,
        inGracePeriod,
        ispreExpired,
        showFreeTrailBlockerState,
        isUpgrade,
        loading,
      ],
    );
    useEffect(
      () => {
        const prcValue = userData?.prcValue ? userData.prcValue : 0;
        if (
          (prcValue !== PRC_FOR_FTU || prcValue !== PRC_FOR_SUBSCRIBED) &&
          (typeof window !== 'undefined' &&
            sessionStorage?.getItem('paidstories')?.length > 0)
        ) {
          setPayPerUSer(true);
        }
        if (prcValue === PRC_FOR_SUBSCRIBED || prcValue === PRC_FOR_FTU) {
          clearAmpParams();
        }
      },
      [userData],
    );

    useEffect(
      () => {
        if (
          userData?.isLoggedIn &&
          (!loading || loading === LOADING_STATE.LOADING)
        ) {
          return;
        }
        if (nudges) {
          if (isUpgrade) {
            setNudgeText(nudges.prc5);
            return;
          }
          let prcValue = getPrcCookieValue();
          let key = '';
          if (
            (frmapp || isAppView) &&
            showFreeTrailBlockerState &&
            (prcValue === PRC_FOR_NEVER_REGISTER ||
              prcValue === PRC_FOR_NOT_LOGIN)
          ) {
            const text = nudges.frmapp_freeTrail || {};
            setNudgeText(text);
            setShowFreeTrailBlocker(true);
          } else if (
            prcValue === PRC_FOR_SUBSCRIBED &&
            inGracePeriod &&
            !frmapp
          ) {
            key = 'grace';
            setShowFreeTrailBlocker(false);
            if (nudges[key]) {
              setReplaceDate(
                nudges[key].h1?.replace('<gracedate>', `${graceDate}`),
              );
              setNudgeText(nudges[key]);
            }
          } else if (
            prcValue === PRC_FOR_SUBSCRIBED &&
            ispreExpired &&
            !frmapp
          ) {
            key = 'preExpiry';
            setShowFreeTrailBlocker(false);
            if (nudges[key]) {
              const days =
                daysRemaining > 1 ? `${daysRemaining} days` : 'Today';
              setPreExpireHeading(
                nudges[key].h1?.replace(
                  `<span class='expriedaysremaining'><remainingDays></span>`,
                  `${
                    daysRemaining > 1 ? 'in' : ''
                  } <span class=expriedaysremaining>${days}</span>`,
                ),
              );
              setNudgeText(nudges[key]);
            }
          } else if (
            prcValue === PRC_FOR_SUBSCRIBED &&
            inGracePeriod &&
            frmapp
          ) {
            key = 'frmappgrace';
            setShowFreeTrailBlocker(false);
            if (nudges[key]) {
              setReplaceDate(
                nudges[key].h1?.replace('<gracedate>', `${graceDate}`),
              );
              setNudgeText(nudges[key]);
            }
          } else {
            setShowFreeTrailBlocker(false);
            while (prcValue >= 0) {
              if (prcValue === PRC_FOR_FTU || prcValue === PRC_FOR_SUBSCRIBED) {
                prcValue = -1;
              }
              key = `prc${prcValue}`;
              if (nudges[key]) {
                setNudgeText(nudges[key]);
                break;
              } else {
                setNudgeText(null);
              }
              prcValue -= 1;
            }
          }
        }
      },
      [
        nudges,
        userData,
        inGracePeriod,
        ispreExpired,
        showFreeTrailBlockerState,
        isUpgrade,
        loading,
      ],
    );

    if (
      !geo ||
      !nudges ||
      (!nudgeText &&
        pageType !== 'storyPagePinkStrip' &&
        pageType !== 'homepage' &&
        pageType !== 'homepagerenewnudge') ||
      ((userData?.prcValue === 1 || userData?.prcValue === 5) &&
        pageType !== 'storyPagePinkStrip' &&
        pageType !== 'homepage' &&
        pageType !== 'homepagerenewnudge') ||
      (userData.prcValue === 1 ||
        (userData.prcValue === 5 && !inGracePeriod && daysRemaining < 0)) ||
      (userData.prcValue !== 5 && inGracePeriod) ||
      (userData.prcValue !== 5 && ispreExpired)
    ) {
      if (
        pageType === 'storypage' ||
        pageType === 'storypagenew' ||
        pageType === 'storyBlockerV3'
      ) {
        return (
          <WrappedComponent
            {...props}
            nudges={nudges}
            nudgeText={nudgeText}
            replaceDate={replaceDate}
            preExpireHeading={preExpireHeading}
            bundleCardMessage={bundleCardMessage}
            storyPageOffers={storyPageOffers}
            geo={geo?.currentCountry}
            daysRemaining={daysRemaining}
            onRetryToipTransCallback={onRetryToipTransCallback}
            showFreeTrailBlocker={showFreeTrailBlocker}
          />
        );
      }
      return null;
    }

    return (
      <WrappedComponent
        {...props}
        nudges={nudges}
        nudgeText={nudgeText}
        replaceDate={replaceDate}
        preExpireHeading={preExpireHeading}
        bundleCardMessage={bundleCardMessage}
        storyPageOffers={storyPageOffers}
        geo={geo?.currentCountry}
        daysRemaining={daysRemaining}
        onRetryToipTransCallback={onRetryToipTransCallback}
        showFreeTrailBlocker={showFreeTrailBlocker}
      />
    );
  };
  const cachedResultIfPresent = (function getCachedResultIfAvailable() {
    let cachedData = { geo: {}, userData: {} };
    return data => {
      if (!_isEqual(cachedData, data)) {
        cachedData = data;
      }

      return cachedData;
    };
  })();

  const mapDispatchToProps = dispatch => ({
    loadTOIPlusNudgeData: (isWapView, countryCode) => {
      dispatch(loadNudgeData(isWapView, countryCode));
    },
    getUserPrcData: (isWapView, params) =>
      dispatch(getUserPrcData(isWapView, params)),
  });

  const mapStateToProps = state => ({
    transLoading: state.translationConfig.transLoading,
    homePagenudges: _get(
      state.translationConfig.nudges,
      'tpHomepageNudgesNew',
      null,
    ),
    storyPageNudges: _get(
      state.translationConfig.nudges,
      'tpArticlePayPerBlockernew',
      null,
    ),
    storyPageNudgesNew: _get(
      state.translationConfig.nudges,
      'storyBlockerNewNudge',
      null,
    ),
    primeStripNudges: _get(
      state.translationConfig.nudges,
      'renewalStoryStrip',
      null,
    ),
    payPerStoryNudges: _get(
      state.translationConfig.nudges,
      'PayPerStoryStrip',
      null,
    ),
    credStoryStrip: _get(
      state.translationConfig.nudges,
      'credStoryStrip',
      null,
    ),
    bundleCardMessage: _get(
      state.translationConfig.nudges,
      'bundleCardMessage',
      null,
    ),
    storyPageOffers: _get(
      state.translationConfig.nudges,
      'toiplusdomain.primeshow.Offers',
      null,
    ),
    PrintHomePage: _get(
      state.translationConfig.nudges,
      'printEdition.blockerNudge.PrintHomePageNew',
      null,
    ),
    PrintStoryPage: _get(
      state.translationConfig.nudges,
      'printEdition.blockerNudge.PrintStoryPageNew',
      null,
    ),
    upgradePlan: _get(
      state.translationConfig.nudges,
      'printEdition.blockerNudge.upgradePlanNew',
      null,
    ),
    toiHPWidget: _get(state.translationConfig.nudges, 'toiHPWidget', null),
    userData: cachedResultIfPresent({
      userData: _get(state, 'login.userData', {}),
      geo: _get(state, 'geo', null),
    })?.userData,
    geo: cachedResultIfPresent({
      userData: _get(state, 'login.userData', {}),
      geo: _get(state, 'geo', null),
    })?.geo,
    userPrcData: state.login.userPrcData,
    loading: state.login.isLoading,
    storyBlockerNewPaywall: _get(
      state.translationConfig.nudges,
      'storyBlockerNewPaywall',
      null,
    ),
    showFreeTrailBlockerState: state.login.showFreeTrailBlocker,
  });

  NudgeLogicHOC.propTypes = {
    isWapView: PropTypes.bool,
    loadTOIPlusNudgeData: PropTypes.func.isRequired,
    userData: PropTypes.shape({
      prcValue: PropTypes.number,
    }),
    geo: PropTypes.shape({
      currentCountry: PropTypes.string,
    }).isRequired,
    viewType: PropTypes.string,
    inGracePeriod: PropTypes.bool,
    graceDate: PropTypes.string,
    daysRemaining: PropTypes.number,
    ispreExpired: PropTypes.bool,
    isUpgrade: PropTypes.bool,
    isAppView: PropTypes.bool,
  };

  NudgeLogicHOC.defaultProps = {
    isWapView: false,
    userData: undefined,
    viewType: '',
    inGracePeriod: false,
    graceDate: '',
    daysRemaining: 0,
    ispreExpired: false,
    isUpgrade: false,
    isAppView: false,
  };

  return connect(mapStateToProps, mapDispatchToProps)(NudgeLogicHOC);
};

export default withNudgeLogic;
